/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Outlet } from 'react-router-dom';
import TripMatchSubNavigation from '../../components/trip-match-sub-navigation';

const View = () => (
  <>
    <TripMatchSubNavigation />
    <Outlet />
  </>
);

export default View;
